module.exports = __webpack_public_path__ + "static/media/LoyalityProgramsCards1.7cec131f.png";